export default __webpack_public_path__ + "static/media/Ideate 2 (edited).17263202.jpg";